const MAP = {
  Confirmed: "bg-[#2C7A51]/10 text-[#2C7A51]",
  Paid: "bg-[#2C7A51]/15 text-[#1f5c3c]",
  Pending: "bg-[#D99338]/15 text-[#a66a1d]",
  Cancelled: "bg-[#7A8C82]/15 text-[#586D61]",
};

export default function StatusBadge({ status }) {
  const cls = MAP[status] || MAP.Pending;
  return (
    <span className={`inline-flex items-center px-3 py-1 rounded-full text-[11px] font-bold uppercase tracking-wider ${cls}`}>
      {status}
    </span>
  );
}
